import { profile } from "./profile";
import { checkout } from "./checkout";

const en = {
  profile,
  checkout,
};
export default en;
